export default __webpack_public_path__ + "static/media/CRS_7118-HDR-min.73692c59.jpg";